import gql from 'graphql-tag'

export const updateRole = (role_id, role, commercial_base) => ({
	mutation: gql`
		mutation (
			$role_id: bigint!
			$role: roles_set_input!
			$commercial_base: [roles_commercial_base_insert_input!]!
		) {
			update_roles_by_pk(pk_columns: { id: $role_id }, _set: $role) {
				id
			}
			delete_roles_commercial_base(where: { role_id: { _eq: $role_id } }) {
				affected_rows
			}
			insert_roles_commercial_base(objects: $commercial_base) {
				affected_rows
			}
		}
	`,
	variables: {
		role_id,
		role,
		commercial_base: commercial_base.map(item => ({
			role_id,
			commercial_base_id: item.id
		}))
	}
})
